import { RootState } from "RootReducer";

export const selectIsForwardingPlan = (state: RootState) => Boolean(state.inbound?.plan?.isForwarding);
